import { IAction } from '~/src/store';
import { EAction } from '~/src/store/actionTypes/agreements';
import { TAgreementsState } from '~/src/store/reducers/agreements';

export const setStatus = (status: TAgreementsState['status']): IAction<EAction.SetStatus, TAgreementsState['status']> => ({
    type: EAction.SetStatus,
    payload: status,
});
